
<div>
    <v-row class="no-frame">
        <v-col class="no-frame">
            <v-combobox
                v-model="value.name"
                class="primary--text"
                prepend-icon = "fas fa-user-tie"
                :label       = "label"
                :items       = "partner"
                item-text    = "name"
                item-value   = "id"
                @input       = "onInput"
                @change      = "onPartner"
                auto-select-first
                autocomplete   = "off"
                autocorrect    = "off"
                autocapitalize = "off"
                spellcheck     = "false"
            >
                <template v-slot:item="data">
                    <div class="partner-select-box">
                        <div class="crm-partner-name" v-html="data.item.name"></div>
                        <div style="font-size: 11px; margin-top: -4px" v-for="(role, index) in data.item.roles" :key="index">
                            {{ role.name }}
                        </div>

                        <!--
                        <div style="font-size: 10pt" v-html="data.item.phone" v-if="data.item.phone"></div>
                        -->
                        <div style="font-size: 15px" v-html="data.item.email" v-if="data.item.email"></div>
                        <v-divider class="mt-2"></v-divider>
                    </div>
                </template>
            </v-combobox>
        </v-col>
    </v-row>
    <v-row class="no-frame">
        <v-col class="no-frame">
            <v-text-field
                v-model        = "value.phone"
                class          = "primary--text mt-0 pt-0"
                prepend-icon   = "fas fa-phone"
                @input         = "onInput"
                autocomplete   = "off"
                autocorrect    = "off"
                autocapitalize = "off"
                spellcheck     = "false"
            />
        </v-col>
    </v-row>
    <v-row class="no-frame">
        <v-col class="no-frame">
            <v-text-field
                v-model="value.email"
                class          = "mt-0 pt-0"
                :rules         = "[rules.email]"
                prepend-icon   = "fas fa-envelope"
                @input         = "onInput"
                autocomplete   = "off"
                autocorrect    = "off"
                autocapitalize = "off"
                spellcheck     = "false"
            />
        </v-col>
    </v-row>
</div>
